export enum OverlayOperation {
  none = 'None',
  runTill = 'RunTill',
  edit = 'Edit',
}
